export enum QueueExternalEventTypeEnum {
  EmailSend = 'email-send',
  SmsSend = 'sms-send',
  PdfConfirmation = 'pdf-confirmation',
  ImageCompress = 'image-compress',
  ImageCompressed = 'image-compressed',
  ImageConvertHeic = 'image-convert-heic',
  ImageConvertedHeic = 'image-converted-heic',
}
